// extracted by mini-css-extract-plugin
export default {"cookieAlert":"CookieAlert_cookieAlert__FANrd","content":"CookieAlert_content__cAZ1G","text":"CookieAlert_text__rd8PM","btn":"CookieAlert_btn__Vpxvf"};